import { AuthApi } from "../../../Shared/Constants/api";
import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { parseResponseError } from "../../../Shared/Utils/errorUtils";
import { loginObject } from "../Data/LoginWrapper";

export const loginApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${AuthApi}/login`,
      loginObject(data)
    );

    return response.data;
  } catch (error) {
    console.error("error", error);
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
export const logout = async (data) => {
  localStorage.removeItem("profileURL");
  localStorage.removeItem("token");
  localStorage.removeItem("auth0_profile");
  localStorage.removeItem("permissions");
  localStorage.removeItem("Name");
  localStorage.setItem("authenticated", false);

  window.location.href = `${process.env.PUBLIC_URL}/login`;
};
